import type { DobSelectProps } from '../DobSelect/index.ts';
import type { FormComponentProps } from './types.ts';
import { DobSelect } from '../DobSelect/index.ts';
import { useFieldContext } from './BaseForm.ts';
import { usePropsFromField } from './utils.ts';

export function FormDobSelect(
  props: FormComponentProps<Omit<DobSelectProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<string | null>();

  return (
    <DobSelect
      key={field.name}
      {...usePropsFromField(props, field)}
      onBlur={field.handleBlur}
      onChange={field.handleChange}
      value={field.state.value}
    />
  );
}
